import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';
import _extends from 'babel-runtime/helpers/extends';

var _templateObject = _taggedTemplateLiteral(['\n  margin-top: 12px;\n  display: flex;\n  &&&& > button {\n    min-width: initial;\n    margin-right: 4px;\n    font-size: 9px;\n  }\n'], ['\n  margin-top: 12px;\n  display: flex;\n  &&&& > button {\n    min-width: initial;\n    margin-right: 4px;\n    font-size: 9px;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  padding: 6px 10px;\n  flex: initial;\n  &:hover {\n    background-color: ', ';\n    .button-label {\n      color: white;\n    }\n  }\n'], ['\n  padding: 6px 10px;\n  flex: initial;\n  &:hover {\n    background-color: ', ';\n    .button-label {\n      color: white;\n    }\n  }\n']);

import React from 'react';
import styled from 'styled-components';
import EveryInput from './EveryInput';
import ReusableButton from '../../../../../ReusableButton';
import { DatePickerButton } from '../../../../..';
import { translations, utils, styles } from 'gipsy-misc';

var WEEKDAYS = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];

var onDayChange = function onDayChange(value, day) {
  var days = value.days;

  if (!days.includes(day)) {
    days = days.concat([day]);
    days.sort();
  } else {
    if (days.length <= 1) {
      return value;
    }
    days = days.concat([]);
    days.splice(days.indexOf(day), 1);
  }
  return _extends({}, value, { days: days });
};

var Weekdays = styled.div(_templateObject);

var WeeklyInput = function WeeklyInput(_ref) {
  var value = _ref.value,
      _onChange = _ref.onChange;

  return React.createElement(
    'div',
    null,
    React.createElement(EveryInput, {
      value: value.every,
      onChange: function onChange(every) {
        return _onChange(_extends({}, value, { every: every }));
      },
      label: translations.taskPanel.recurrency.week
    }),
    React.createElement(
      Weekdays,
      null,
      WEEKDAYS.map(function (day, i) {
        return React.createElement(
          DayButton,
          {
            key: day,
            onClick: function onClick() {
              return _onChange(onDayChange(value, i));
            },
            height: 32,
            fontSize: 9,
            borderRadius: 4,
            textColor: value.days.includes(i) ? 'white' : styles.colors.textLightColor,
            backgroundColor: value.days.includes(i) ? styles.colors.greenColor : styles.colors.lightGrey },
          utils.string.capitalize(translations.days.shortLabel[day])
        );
      })
    )
  );
};

export default WeeklyInput;

export var DayButton = styled(ReusableButton)(_templateObject2, styles.colors.greenColor);
//# sourceMappingURL=WeeklyInput.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-ui/lib/TaskPanel/fields/When/RecurrencyDetails/components/WeeklyInput.js
// module id = 1101
// module chunks = 0